/* Simplified fork from v1.3.0 https://github.com/Emiliano-Bucci/react-spring-carousel-js */
import React, { useRef } from 'react';
import { useSpring } from '@react-spring/web';
import { AnimatedThumbWrapper, ThumbWrapper, } from '../components/thumbs/styled-components';
export function useThumbsModule({ items, withThumbs, springConfig }) {
    const thumbsWrapperRef = useRef(null);
    const [thumbListStyles] = useSpring(() => ({
        x: 0,
        config: springConfig,
    }));
    const thumbsFragment = withThumbs ? (React.createElement(AnimatedThumbWrapper, { ref: thumbsWrapperRef, scrollLeft: thumbListStyles.x }, items.map(({ id, renderThumb }) => (React.createElement(ThumbWrapper, { key: `thumb-${id}`, itemsCount: items.length }, renderThumb))))) : null;
    return {
        thumbsFragment,
    };
}
